// function matchImageHeights(container, items, image_class, items_to_ignore) {
//     var _this, current_row, extra_ignore_blocks, greatest_image_height, ignore_item_rows, ignore_item_widths, image_roots, images, items_per_row, row_items;
//     if (items_to_ignore == null) {
//       items_to_ignore = false;
//     }
//     _this = this;
//     if (!items.length) {
//       return;
//     }
//     images = items.find(image_class + ", .placeholder--root").css('height', 'auto');
//     image_roots = items.find(image_class + " .image--root, .placeholder--root");
//     items_per_row = Math.floor(container.width() / image_roots.width());
//     if (isNaN(items_per_row)) {
//       return;
//     }
//     if (items_to_ignore) {
//       ignore_item_rows = [];
//       ignore_item_widths = [];
//       extra_ignore_blocks = 0;
//       items_to_ignore.each(function(item) {
//         var item_el, row, width;
//         item_el = el(item);
//         row = Math.floor((extra_ignore_blocks + item_el.index()) / items_per_row) + 1;
//         width = Math.floor(item_el.width() / image_roots.width());
//         extra_ignore_blocks += width - 1;
//         if (ignore_item_rows.includes(row)) {
//           return ignore_item_widths[ignore_item_rows.indexOf(row)] += width;
//         } else {
//           ignore_item_rows.push(row);
//           return ignore_item_widths.push(width);
//         }
//       });
//     }
//     row_items = el();
//     current_row = 1;
//     greatest_image_height = 0;
//     return items.each(function(item, index) {
//       var end_of_row, item_el, number_items_to_skip, this_height;
//       item_el = el(item);
//       if (item_el.find('.image--root').length > 0) {
//         this_height = item_el.find(image_class + " .image--root").outerHeight();
//       } else {
//         this_height = item_el.find('.placeholder--root').outerHeight();
//       }
//       if (this_height > greatest_image_height) {
//         greatest_image_height = this_height;
//       }
//       end_of_row = false;
//       row_items = row_items.add(item_el);
//       if (index + 1 === items.length) {
//         end_of_row = true;
//       } else if (items_to_ignore && ignore_item_rows.includes(current_row)) {
//         number_items_to_skip = ignore_item_widths[ignore_item_rows.indexOf(current_row)];
//         if (number_items_to_skip === items_per_row) {
//           current_row++;
//         } else {
//           end_of_row = (row_items.length + number_items_to_skip) === items_per_row;
//         }
//         if (number_items_to_skip === 1 && items_per_row === 1) {
//           end_of_row = true;
//         }
//       } else if (row_items.length === items_per_row) {
//         end_of_row = true;
//       }
//       if (end_of_row) {
//         row_items.find(image_class + ", .placeholder--root").height(greatest_image_height);
//         row_items = el();
//         current_row++;
//         return greatest_image_height = 0;
//       }
//     });
// };




function renderLettersDropdown(options){
  let lettersCount = 0;
  let lettersDropdownWrapper = document.querySelector('.product-letters__wrapper');
  let lettersDropdowns = document.querySelectorAll('.product-letters__wrapper select');
  
  options.forEach(option => {
    if(option.indexOf('Letters') != -1 || option.indexOf('Letter') != -1 || option.indexOf('letters') != -1 || option.indexOf('letter') != -1){
      lettersCount = parseInt(option.match(/\d+/)[0]);
    }
  });

  console.log(options)

  if(lettersCount && lettersDropdownWrapper){
    lettersDropdowns.forEach((elem)=>{
      elem.required = false;
      elem.disabled = true;
      elem.style.display = 'none';
    })

    
    for(let i = 0; i < lettersCount; i++){
      lettersDropdowns[i].required = true;
      lettersDropdowns[i].disabled = false;
      lettersDropdowns[i].style.display = 'block';
    }
  }
}



// NEW IP REDIRECT SCRIPT

// function isSearchBot() {
//   var bots = [
//     'Googlebot',
//     'Bingbot',
//     'Slurp',
//     'DuckDuckBot',
//     'Baiduspider',
//     'YandexBot',
//     'Sogou',
//     'Exabot',
//     'SnapchatBot',
//    'Snapchat',
//     'facebot',
//     'ia_archiver',
//      'AhrefsBot',  
//     'Mediapartners-Google', 
//     'Google-Structured-Data-Testing-Tool', // Schema Validator
//     'Google-Structured-Data-Validator', // Another identifier for Google's schema validator
    
//     // Google Ads & PMAX Related Crawlers
//     'AdsBot-Google',
//     'AdsBot-Google-Mobile',
//     'Google-InspectionTool',
//     'GoogleOther',

//     // Performance Max & Ad-related Crawlers (Blocked from redirection manipulation)
//     'Google-Adwords-Instant',
//     'Google-Adwords-DisplayAds',
//     'Google-Adwords-PMAX',
//     'Google-Adwords-Optimizer',

//     // Additional Google Crawlers that should not be redirected
//     'Google-Publisher-Plugin',
//     'Google-Read-Aloud',
//     'Google-Site-Verification',
//     'Google-Favicon'

    
//   ];
// var userAgent = navigator.userAgent;

//   for (var i = 0; i < bots.length; i++) {
//     if (userAgent.indexOf(bots[i]) !== -1) {
//       return true;
//     }
//   }

//   return false;
// }
// function redirectToLocalShop(url){
//   document.getElementById('redirectPopup').style.display = 'block';
  

//   setTimeout(() => {
//     window.location.href = url;
//   }, 1000);
// }

// function readIPInfo(){
//   var ip = '';
//   var XMLHttp = new XMLHttpRequest();
//   XMLHttp.onreadystatechange = function() {
//     if(this.readyState == 4 && this.status == 200) {
//       var ipwhois = JSON.parse(this.responseText);

//       let storeUrl = window.location.href;
//       console.log(ipwhois.country_code)
//       if (ipwhois.country_code === 'IL' && storeUrl.indexOf('il.heniadanielle.com') == -1 && storeUrl.indexOf('zirhy1-gi.myshopify.com') == -1){
//         redirectToLocalShop('https://il.heniadanielle.com/');
//       }else{
//         if(ipwhois.country_code != 'IL' && storeUrl.indexOf('www.heniadanielle.com') == -1 && storeUrl.indexOf('henia-danielle.myshopify.com') == -1){
//           redirectToLocalShop('https://www.heniadanielle.com/');
//         }
//       }

//       console.log('Your country code is - ' + ipwhois.country_code + ' ' + ipwhois.flag.emoji);
//     }
//   };
//   XMLHttp.open('GET', 'https://ipwhois.pro/' + ip + '?key=1vti6PIiYqSMAT7o', true);
//   XMLHttp.send();
// }



// let isPreview = window.location.href.indexOf('shopifypreview.com');

// // Only perform redirection if it's not a search bot
// if (!sessionStorage.getItem('firstVisitPerSession') && isPreview == -1 && !isSearchBot()) {
//   readIPInfo();
//   sessionStorage.setItem('firstVisitPerSession', 'true');
// }

